'use client';

import React, { useState } from 'react';

import { FormSubmissionModal } from '@/components/forms/FormSubmissionModal/FormSubmissionModal';
import {
  tmjEnquirySchema,
  tmjEnquiryDefaultValues,
  tmjEnquiryFields,
} from '@/features/tmj/forms/tmjEnquirySchema';

import PackagesSection from '@/components/sections/PackagesSection';
import type { PackagesSectionProps } from '@/components/sections/PackagesSection/types';

export default function TmjPackagesWithModal({
  data,
}: PackagesSectionProps): React.ReactElement {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [hasBeenOpened, setHasBeenOpened] = useState(false);
  const [enquiryTitle, setEnquiryTitle] = useState<string>(
    'Enquire about this package',
  );
  const [selectedPackage, setSelectedPackage] = useState<{
    title?: string;
    price?: string;
  } | null>(null);

  return (
    <>
      <PackagesSection
        data={data}
        showViewAllButton={false}
        categoryLabel="Maxillofacial"
        includedLabel="Add-ons"
        onEnquire={(payload) => {
          setSelectedPackage({
            title: payload.title,
            price: payload.price,
          });
          setEnquiryTitle(
            payload.title
              ? `Enquire about ${payload.title}`
              : 'Enquire about this package',
          );
          setHasBeenOpened(true);
          setEnquiryOpen(true);
        }}
      />
      {hasBeenOpened && (
        <FormSubmissionModal
          open={enquiryOpen}
          onOpenChange={setEnquiryOpen}
          formId="tmjEnquiry"
          schema={tmjEnquirySchema}
          fields={tmjEnquiryFields}
          defaultValues={tmjEnquiryDefaultValues}
          title={enquiryTitle}
          description="Fill in your details and our team will contact you."
          submitLabel="Send enquiry"
          metadata={{
            serviceName: 'TMJ',
            pageType: 'service',
            source: 'tmj-packages',
            packageName: selectedPackage?.title,
            packagePrice: selectedPackage?.price,
          }}
        />
      )}
    </>
  );
}
